function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPrimaryWhiteLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 1940 885",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M0,598.103l216.238,-0l-0,-25.929l-216.238,-0l0,25.929Zm0,139.918l167.804,0l0,-25.929l-167.804,0l0,25.929Zm0,139.919l216.238,-0l-0,-25.929l-216.238,-0l0,25.929Z",
    style: {
      fill: "#fff",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M475.527,743.403c43.052,-4.893 77.298,-40.117 77.298,-84.636c0,-47.945 -39.627,-86.593 -87.082,-86.593l-127.199,-0l15.655,25.439l111.544,0c33.757,0 60.664,27.397 60.664,61.154c-0,33.756 -26.907,61.153 -60.664,61.153l-37.181,-0l96.377,158.02l32.778,-0l-82.19,-134.537Zm-129.644,134.537l28.375,-0l-0,-140.897l-28.375,-45.988l-0,186.885Z",
    style: {
      fill: "#fff",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M666.326,598.103l216.237,-0l0,-25.929l-216.237,-0l-0,25.929Zm-0,139.918l167.804,0l0,-25.929l-167.804,0l-0,25.929Zm-0,139.919l216.237,-0l0,-25.929l-216.237,-0l-0,25.929Z",
    style: {
      fill: "#fff",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1126.2,877.94l34.735,-0c47.944,-0 86.593,-38.649 86.593,-86.593c-0,-46.477 -36.692,-77.298 -62.621,-82.679c18.101,-12.231 29.843,-34.246 29.843,-58.218c-0,-43.052 -34.735,-78.276 -78.276,-78.276l-131.602,-0l15.655,25.439l115.947,0c28.864,0 52.347,23.972 52.347,52.837c-0,29.353 -23.483,53.325 -52.347,53.325l-51.369,0l15.655,25.929l60.175,0c33.756,0 60.664,27.886 60.664,61.643c-0,33.756 -26.908,61.153 -60.664,61.153l-50.39,-0l15.655,25.44Zm-117.414,-0l28.375,-0l-0,-145.79l-28.375,-46.476l-0,192.266Z",
    style: {
      fill: "#fff",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1376.19,648.004l0,-76.32l-28.375,0l0,29.843l28.375,46.477Zm139.919,230.425c53.815,-14.188 87.571,-58.707 87.571,-133.069l0,-173.676l-28.375,0l0,175.143c0,63.11 -27.886,98.824 -73.384,108.608l14.188,22.994Zm-62.621,3.425l-20.058,-32.779c-33.757,-12.719 -54.794,-44.519 -56.261,-92.952l-29.354,-48.434l0,39.138c0,80.722 41.584,126.22 105.673,135.027Z",
    style: {
      fill: "#fff",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1912.87,625.499l17.123,-22.504c-30.821,-24.461 -66.046,-37.671 -108.608,-37.671c-22.505,0 -43.052,5.871 -58.707,15.656l14.187,22.993c10.763,-7.338 25.929,-12.72 43.541,-12.72c33.268,0 64.089,12.231 92.464,34.246Zm20.058,195.691c4.403,-6.85 6.36,-14.677 6.36,-23.973c0,-47.454 -32.289,-71.426 -103.716,-86.592c-49.412,-10.763 -72.405,-22.016 -82.19,-38.16l-27.886,-45.987c-4.403,5.381 -6.849,13.698 -6.849,23.483c0,48.922 32.778,71.916 105.184,87.082c47.455,10.273 70.938,21.526 80.722,37.67l28.375,46.477Zm-100.78,63.599c25.929,-0 47.944,-5.871 64.577,-16.634l-14.187,-23.483c-12.231,8.806 -29.354,14.188 -48.923,14.188c-41.584,-0 -76.319,-15.655 -109.097,-45.009l-18.101,20.548c35.713,32.778 77.787,50.39 125.731,50.39Z",
    style: {
      fill: "#fff",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M1101.62,15.297l-395.682,343.976l-39.612,-2.85l6.701,-39.145l428.593,-301.981Z",
    style: {
      fill: "#008cff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1182.59,0l-333.447,339.996l-36.176,0.152l3.15,-36.039l366.473,-304.109Z",
    style: {
      fill: "#008cff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1231.51,0.549l-273.485,334.585l-33.69,2.081l-1.008,-33.74l308.183,-302.926Z",
    style: {
      fill: "#008cff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1260.48,16.46l-217.321,324.258l-30.987,4.017l-4.567,-30.91l252.875,-297.365Z",
    style: {
      fill: "#008cff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1279.54,45.622l-162.61,310.64l-28.943,5.451l-8.563,-28.18l200.116,-287.911Z",
    style: {
      fill: "#008cff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1297.47,84.751l-111.73,293.527l-27.679,6.551l-12.846,-25.377l152.255,-274.701Z",
    style: {
      fill: "#b2e5ff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1320,129.721l-63.842,273.13l-27.506,7.563l-17.787,-22.303l109.135,-258.39Z",
    style: {
      fill: "#b2e5ff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1351.6,175.982l-22.207,250.364l-25.658,9.572l-20.566,-18.084l68.431,-241.852Z",
    style: {
      fill: "#b2e5ff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1394.39,218.869l19.708,224.532l-27.873,11.614l-27.004,-13.512l35.169,-222.634Z",
    style: {
      fill: "#b2e5ff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1450.24,253.896l50.861,197.014l-27.786,14.414l-30.24,-8.081l7.165,-203.347Z",
    style: {
      fill: "#b2e5ff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1515.24,277.167l83.724,166.647l-27.327,19.089l-33.327,-0.672l-23.07,-185.064Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1588.77,285.538l103.964,135.395l-24.348,22.801l-32.818,5.969l-46.798,-164.165Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1665.94,277.027l120.948,102.366l-20.382,26.896l-31.081,13.143l-69.485,-142.405Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1741.37,250.957l128.109,74.04l-15.12,28.704l-27.142,17.772l-85.847,-120.516Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1804.8,220.913l134.49,23.023l-4.067,29.925l-17.943,24.292l-112.48,-77.24Z",
    style: {
      fill: "#fff"
    }
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrimaryWhiteLogo);
export default __webpack_public_path__ + "static/media/primary_white_logo.58c528e4ef3337afde78c9f07a7816d9.svg";
export { ForwardRef as ReactComponent };